import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ResultsStyled,
  ImageContainer,
  TextContainer,
  Title,
  Text,
} from './style';

interface Props {
  resultImage: string;
  text: string;
}

const Results: FC<Props> = (props) => {
  const { t } = useTranslation();
  return (
    <ResultsStyled>
      <div className="container">
        <ImageContainer>
          <Title>{t('UseCaseResultsTitle')}</Title>
          <img src={props.resultImage} alt="result" />
        </ImageContainer>
        <TextContainer>
          <Title>{t('UseCaseResultsTitle')}</Title>
          <Text dangerouslySetInnerHTML={{ __html: props.text }} />
        </TextContainer>
      </div>
    </ResultsStyled>
  );
};

export default Results;
